export const accountMenuStyles = {
  root: 'flex min-w-0 items-center gap-1 text-sm min-[1274px]:gap-2',
  loading:
    'h-11 w-11 shrink-0 animate-pulse rounded-md bg-bg-subtle min-[1274px]:h-8 min-[1274px]:w-20 min-[1274px]:rounded-full',
  icon: 'h-5 w-5 shrink-0',
  mobileOnly: 'min-[1274px]:hidden',
  mobileTrigger:
    'inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-md text-fg-secondary transition-colors hover:bg-bg-subtle hover:text-fg-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent data-[state=open]:bg-bg-muted data-[state=open]:text-accent',
  menu: 'z-overlay w-72 max-w-[calc(100vw-1.5rem)] rounded-xl border border-border-strong bg-bg-muted p-2 text-fg-primary shadow-2xl ring-1 ring-accent/20',
  menuHeading:
    'min-w-0 truncate px-3 py-2 text-sm font-semibold normal-case tracking-normal text-fg-primary',
  separator: 'mx-1 my-2 bg-border-strong',
  sectionLabel: 'px-3 py-1 text-xs font-semibold uppercase tracking-wide text-fg-secondary',
  primaryItem:
    'flex min-h-11 items-center gap-3 rounded-lg bg-accent px-3 py-2 text-sm font-semibold text-accent-fg outline-none transition-colors hover:bg-accent-hover focus:bg-accent-hover focus:text-accent-fg',
  preferenceItem:
    'flex min-h-11 w-full items-center gap-3 rounded-lg px-3 py-2 text-sm text-fg-primary outline-none transition-colors hover:bg-bg-subtle focus:bg-bg-subtle',
  preferenceValue: 'ml-auto shrink-0 text-xs font-medium text-fg-secondary',
  itemText: 'min-w-0 flex-1 truncate',
  chevron: 'h-4 w-4 shrink-0',
  signOutItem:
    'flex min-h-11 w-full items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium text-danger outline-none transition-colors hover:bg-danger/10 focus:bg-danger/10 focus:text-danger',
  desktopAccount: 'hidden items-center gap-1 min-[1274px]:flex min-[1274px]:gap-2',
  desktopLink:
    'inline-flex h-10 min-w-0 items-center gap-2 rounded-md px-2 text-fg-secondary hover:bg-bg-subtle hover:text-fg-primary',
  displayName: 'hidden max-w-28 truncate min-[1274px]:inline',
  desktopLogout: 'px-2 xl:px-3',
  desktopLogoutIcon: 'h-4 w-4',
  desktopLogoutLabel: 'hidden xl:inline',
  guestLink:
    'hidden h-10 shrink-0 items-center gap-2 rounded-full border border-border-subtle px-3 text-sm font-medium text-fg-secondary transition-colors hover:bg-bg-subtle hover:text-fg-primary focus-visible:ring-2 focus-visible:ring-accent min-[1274px]:inline-flex',
} as const;
